var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4354 22.08C18.7107 22.2064 19.0208 22.2353 19.3147 22.1619C19.6085 22.0885 19.8686 21.9171 20.0521 21.6761L20.5252 21.0564C20.7735 20.7254 21.0955 20.4567 21.4656 20.2716C21.8357 20.0865 22.2439 19.9902 22.6577 19.9902H26.656C27.363 19.9902 28.041 20.271 28.5409 20.7709C29.0407 21.2708 29.3216 21.9488 29.3216 22.6557V26.6541C29.3216 27.361 29.0407 28.039 28.5409 28.5389C28.041 29.0388 27.363 29.3196 26.656 29.3196C20.2935 29.3196 14.1915 26.7921 9.69253 22.2931C5.19353 17.7941 2.66602 11.6922 2.66602 5.32962C2.66602 4.62267 2.94685 3.94467 3.44674 3.44479C3.94663 2.9449 4.62462 2.66406 5.33157 2.66406H9.32991C10.0369 2.66406 10.7149 2.9449 11.2147 3.44479C11.7146 3.94467 11.9955 4.62267 11.9955 5.32962V9.32795C11.9955 9.74177 11.8991 10.1499 11.7141 10.52C11.529 10.8902 11.2603 11.2121 10.9292 11.4604L10.3055 11.9282C10.0608 12.115 9.88837 12.3808 9.81742 12.6804C9.74648 12.9799 9.78143 13.2948 9.91633 13.5715C11.7378 17.2711 14.7336 20.2631 18.4354 22.08Z",
    stroke: "white",
    strokeWidth: 2.66556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.6c1e304744d15ad132a8f5f2e4acb605.svg";
export { ForwardRef as ReactComponent };